import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, copy }) {
  return (
    <section className="relative pt-36 md:pt-44 pb-10 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30 mask-fade-b" />
      <div className="absolute inset-0 bg-[radial-gradient(900px_400px_at_80%_0%,rgba(139,92,246,0.12),transparent_60%),radial-gradient(700px_350px_at_10%_10%,rgba(0,229,255,0.1),transparent_60%)]" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="eyebrow">{eyebrow}</div>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white max-w-4xl leading-[1.02]">
            {title}
          </h1>
          {copy && <p className="mt-6 text-slate-400 text-lg max-w-2xl leading-relaxed">{copy}</p>}
        </motion.div>
      </div>
    </section>
  );
}
